import React, { useState } from 'react'
import { navigate } from 'gatsby'

import icon_2 from '../../../assets/images/icon-2.png'
import AppSlider from '../../atoms/appSlider/appSlider'
import Button from '../../atoms/button/button'

import { imagesWallpapers } from './wallpapers'

import './wallpapersSection.scss'
import Show from '../../../utils/show'
import { LOCALE, TROPICALIZED } from '../../../constants/activity-constants'

const SliderWallpapersSelector = ({ index = 0, onChange }) => {
  const settings = {
    dots: false,
    initialSlide: index,
    afterChange: onChange,
  }

  return (
    <section className="f-wallpapersSection-container__right">
      <AppSlider settings={settings}>
        {imagesWallpapers.map((item, i) => {
          return (
            <img
              src={item.mobile}
              key={i}
              className="f-wallpapersSection-container__right__image"
              alt="personaje nosotras navideño"
            />
          )
        })}
      </AppSlider>
      <Button
        text="Comienza ya"
        className="f-button-wallpaperSection"
        onClick={() => {
          navigate(`/wallpapers?id=${index}`)
        }}
        metric={{
          event: 'Interacciones_Home_Navidad',
          category: 'Wallpapers',
        }}
      />
    </section>
  )
}
const WallpapersSection = () => {
  const [card, setCard] = useState(0)

  return (
    <div className="f-wallpapersSection-container">
      <div className="f-wallpapersSection-container__ancla" id="wallpapers" />
      <div className="f-wallpapersSection-wrapper">
        <section className="f-wallpapersSection-container__left">
          <figure>
            <img src={icon_2} alt="personaje nosotras navideño" />
            <h1>¡Wallpapers navideños!</h1>
          </figure>
          <p>
            <Show valid={TROPICALIZED}>
              En esta Navidad, <b> personalizá tu celular y tu computador </b>
              con los diseños exclusivos que traemos para vos.{' '}
              <b> ¡Canjeá 10 puntos,</b> descargalos y sorprendete!
            </Show>
            <Show valid={TROPICALIZED === false}>
              En esta Navidad, <b> personaliza tu celular y tu computador </b>
              con los diseños exclusivos que traemos para ti.{' '}
              <b>
                {LOCALE !== 'es-BO' &&
                  (['es-PE', 'es-CL'].includes(LOCALE)
                    ? 'Canjea 10 puntos,'
                    : 'Redime 10 puntos,')}
              </b>{' '}
              ¡Descárgalos y sorpréndete!
            </Show>
          </p>
          {LOCALE !== 'es-BO' && (
            <span className="f-romboPuntosRedeem f-wallpapersSection-cover">
              <b className="f-romboPuntosRedeem__numero">10</b>
            </span>
          )}
        </section>
        <SliderWallpapersSelector
          index={card}
          onChange={_index => {
            setCard(_index)
          }}
        />
      </div>
    </div>
  )
}

export default WallpapersSection
